import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgChooseAgent = (props) => (
  <SvgIcon {...props} title="ChooseAgent">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#Choose-agent_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.219.072A1.656 1.656 0 0 0 5.527.6c-.269.366-.277.43-.277 2.242V4.5l-1.418.001c-1.593.001-1.635.009-1.979.352-.373.373-.35.11-.352 4.23v3.667H.995c-.42 0-.53.016-.656.094-.463.282-.463 1.03 0 1.313.24.146 14.08.146 14.32 0 .372-.227.342.39.329-6.75l-.012-6.352-.109-.22a1.672 1.672 0 0 0-.703-.703l-.22-.108-3.773-.01C7.016.008 6.369.018 6.219.073ZM13.5 3v1.5h-.879c-1.149 0-1.37.122-1.37.75s.221.75 1.37.75h.88v1.5h-.88c-1.149 0-1.37.122-1.37.75s.221.75 1.37.75h.88v3.75H9.75V9.082c-.002-4.119.02-3.856-.353-4.229-.33-.329-.428-.35-1.604-.352H6.75v-3h6.75V3Zm5.18.066c-2.463.566-3.686 3.335-2.454 5.56.491.887 1.83 1.827 2.605 1.827.213 0 .07.063-.329.144-1.662.337-3.064 1.75-3.413 3.441-.136.657-.132 3.398.005 3.623.171.281.33.339.938.339h.54l.342 2.754c.368 2.952.365 2.94.662 3.14.246.166 3.602.166 3.848 0 .297-.2.294-.188.662-3.14L22.429 18h.54c.607 0 .766-.058.938-.34.136-.224.14-2.965.005-3.622-.35-1.69-1.752-3.104-3.414-3.441-.398-.08-.542-.144-.328-.144.953 0 2.365-1.146 2.83-2.299 1.117-2.765-1.42-5.754-4.32-5.088Zm1.148 1.482c.69.108 1.355.603 1.666 1.241 1.085 2.223-1.805 4.273-3.555 2.523-1.375-1.374-.464-3.662 1.514-3.806.039-.003.208.016.375.042ZM8.25 6.75v.75H6.996c-1.57 0-1.746.076-1.746.75S5.426 9 6.996 9H8.25v3.75H3V6h5.25v.75Zm11.977 5.37c1.003.24 1.88 1.115 2.16 2.154.054.197.084.57.1 1.253l.025.973h-.515c-.975 0-.909-.162-1.333 3.246l-.342 2.754H18.679l-.343-2.754c-.424-3.408-.358-3.246-1.333-3.246h-.515l.024-.973c.035-1.41.206-1.913.878-2.594.781-.79 1.76-1.07 2.837-.812Z"
          fill="#017163"
        />
      </g>
      <defs>
        <clipPath id="Choose-agent_svg__a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);

export default SvgChooseAgent;
